// extracted by mini-css-extract-plugin
export default {"btnpwd":"_5fe55cebfe"};